import React from 'react';
import { faBold } from '@fortawesome/pro-duotone-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { createInlineStyleButton } from 'draft-js-buttons';

export default createInlineStyleButton({
    style: 'BOLD',
    children: (
        <FontAwesomeIcon icon={faBold} />
    )
});